import { render, staticRenderFns } from "./ConsultList.vue?vue&type=template&id=33e7cbd6&scoped=true&"
import script from "./ConsultList.vue?vue&type=script&lang=js&"
export * from "./ConsultList.vue?vue&type=script&lang=js&"
import style0 from "./ConsultList.vue?vue&type=style&index=0&id=33e7cbd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e7cbd6",
  null
  
)

export default component.exports